import { createAsyncThunk } from '@reduxjs/toolkit';
import { nameReducer } from '../controlUnit.model';
import { MonitoringCalls } from '../../../service/monitoring/MonitoringCalls';

// ------------------------------------
// Thunks created with @reduxjs/toolkit
// ------------------------------------

export const fetchCurrentEventsControlUnits = createAsyncThunk(
  `${nameReducer}/fetchCurrentEventsControlUnits`,
  async (params: { deviceId: string; commanderId: string }) => {
    const { deviceId, commanderId } = params;
    const monitoringCalls = new MonitoringCalls();
    const response = await monitoringCalls.getCurrentEventsByID({
      deviceId,
      commanderId,
    });
    return response;
  }
);

export const fetchCurrentSensorDataControlUnits = createAsyncThunk(
  `${nameReducer}/fetchCurrentSensorDataControlUnits`,
  async (commanderId: string) => {
    const monitoringCalls = new MonitoringCalls();
    const response = await monitoringCalls.getCurrentSensorDataByID(
      commanderId
    );
    return response;
  }
);
